import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import SVGInline from 'react-svg-inline';

import Input from '../../Input/Input';
import styles from './Search.scss';
import magnifierIcon from '../../Icon/magnifier.svg';
import { SearchLocale } from './search.locale';

export interface FormData {
  search: string;
}

interface OwnProps {
  locale: SearchLocale;
}

interface SearchProps extends InjectedFormProps<FormData, OwnProps>, OwnProps {}

const Search: React.SFC<SearchProps> = ({ handleSubmit, locale }) => (
  <form onSubmit={handleSubmit} className={styles.container}>
    <Field
      name="search"
      component={Input}
      props={{ className: styles.input, placeholder: locale.placeholder }}
    />
    <SVGInline svg={magnifierIcon} component="button" className={styles.button} />
  </form>
);

export default reduxForm<FormData, OwnProps>({
  form: 'networksSearch',
  initialValues: {
    search: '',
  },
  onSubmit: () => ({}),
})(Search);



// WEBPACK FOOTER //
// /www/client/src/components/NetworksPage/Search/Search.tsx